declare namespace $ {

	type $mol_string__enabled_shm_hitalama_components_settings_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_shm_hitalama_components_settings_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_components_settings_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_components_settings_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['Name_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_textarea__enabled_shm_hitalama_components_settings_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['editable'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_shm_hitalama_components_settings_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['description'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_labeler__title_shm_hitalama_components_settings_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_components_settings_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['Description_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_components_settings_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__enabled_shm_hitalama_components_settings_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['editable'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_check_box__checked_shm_hitalama_components_settings_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['widget_type'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_string__enabled_shm_hitalama_components_settings_12 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_shm_hitalama_components_settings_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['fqn'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_components_settings_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_components_settings_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['Fqn_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_confirm_delete__title_shm_hitalama_components_settings_16 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['title'] >
	>
	type $shm_confirm_delete__question_shm_hitalama_components_settings_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['remove_question'] >
		,
		ReturnType< $shm_confirm_delete['question'] >
	>
	type $shm_confirm_delete__trigger_enabled_shm_hitalama_components_settings_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['remove_enabled'] >
		,
		ReturnType< $shm_confirm_delete['trigger_enabled'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_components_settings_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['remove'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_string__enabled_shm_hitalama_components_settings_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['repository_editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__hint_shm_hitalama_components_settings_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_components_settings_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['repository'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_components_settings_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_components_settings_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['Repository_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_text__text_shm_hitalama_components_settings_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_status__status_shm_hitalama_components_settings_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_status__attr_shm_hitalama_components_settings_27 = $mol_type_enforce<
		({ 
			'data-sync-state': ReturnType< $shm_hitalama_components_settings['sync_state'] >,
		})  & ReturnType< $mol_status['attr'] >
		,
		ReturnType< $mol_status['attr'] >
	>
	type $mol_button_minor__title_shm_hitalama_components_settings_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_settings_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['refresh'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_hitalama_components_settings_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_hitalama_components_settings_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['commit_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_hitalama_components_settings_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_settings['commit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_components_settings_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_components_settings extends $mol_view {
		editable( ): boolean
		name( next?: string ): string
		Name_input( ): $mol_string
		Name( ): $mol_labeler
		description( next?: string ): string
		Description_input( ): $mol_textarea
		Description( ): $mol_labeler
		widget_type( next?: boolean ): boolean
		Widget_type( ): $mol_check_box
		fqn( ): string
		Fqn_input( ): $mol_string
		Fqn( ): $mol_labeler
		remove_question( ): string
		remove_enabled( ): boolean
		remove( next?: any ): any
		Remove( ): $shm_confirm_delete
		repository_editable( ): boolean
		repository( next?: string ): string
		Repository_input( ): $mol_string
		Repository( ): $mol_labeler
		Github_hint( ): $mol_text
		status( ): string
		sync_state( ): string
		Status( ): $mol_status
		refresh( next?: any ): any
		Refresh( ): $mol_button_minor
		commit_enabled( ): boolean
		commit( next?: any ): any
		Commit( ): $mol_button_major
		Actions( ): $mol_view
		definition( ): $shm_hitalama_map_widget_entity_custom
		saving( ): boolean
		save_error( ): string
		removed( next?: any ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map